export class ClearBasketAction {
  static type = '[BASKET] Clear';
}
